import { useEffect } from 'react';
import { hydrateSyncTimestampsFromStorage } from '../../sync/core/syncTimestamps';

/**
 * ADR-017 Fase 4: SQLite was eliminated. This hook now only hydrates
 * sync timestamps from AsyncStorage/localStorage at boot.
 */
export function useInitDatabase(): void {
  useEffect(() => {
    void hydrateSyncTimestampsFromStorage().catch(() => {
      // Best-effort: si falla, los timestamps se repoblarán tras el primer pull.
    });
  }, []);
}
